export const downloadBlob = (data: BlobPart, fileName: string, contentType?: string) => {
  const blob = new Blob([data], {
    type: contentType || 'application/octet-stream',
  });

  const downloadUrl = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = fileName;

  document.body.appendChild(link);
  link.click();

  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
};
